import { createContext, useContext, useEffect, useReducer, useState } from "react"
import FileNavigator from "../components/FileNavigator";
import * as apiFN from "../api/apiFileNavigator";
import { fileNavigatorReducer, initialState } from "./reducer/FileNavigatorReducer";

const FileNavigatorContext = createContext();
export const useFileNavigator = () => useContext(FileNavigatorContext)
 
export const FileNavigatorProvider = ({children}) =>{

    const [stateFN, dispatchFN ] = useReducer(fileNavigatorReducer, initialState);

    // Оновлення даних навігатора
    const fetchDataFN = async (force=false, beforeNull = true) => {
        if ((!stateFN.dataFN) || (force)) {
            dispatchFN({type:'TOGGLE_SELECTED', payload:null})
            if (beforeNull) dispatchFN({type:'SET_DATA_FN', payload:null})            
            const resData = await apiFN.getList();
            dispatchFN({type:'SET_DATA_FN', payload:resData.data}) 
        }
    }  
 
    useEffect(()=>{
        fetchDataFN();
    }, [])
   
    useEffect(()=>{ 
        // При зміні папки - знімаємо всі помітки з файлів
        dispatchFN({type:'TOGGLE_SELECTED', payload:null})
    }, [stateFN.currentPathFN]);

    
  
    return (
        <FileNavigatorContext.Provider 
            value={{
                stateFN,
                dispatchFN,
                fetchDataFN,
            }}>
            {children}
            <FileNavigator/>
        </FileNavigatorContext.Provider>
    )
}